import { RestrictivePracticeStatus } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

export const restrictivePracticeStatusOptions = {
  [RestrictivePracticeStatus.Ongoing]: {
    label: 'Ongoing',
    value: RestrictivePracticeStatus.Ongoing,
    raw: RestrictivePracticeStatus.Ongoing,
    color: 'blue',
  },
  [RestrictivePracticeStatus.Ceased]: {
    label: 'Ceased',
    value: RestrictivePracticeStatus.Ceased,
    raw: RestrictivePracticeStatus.Ceased,
    color: 'green',
  },
};

interface Props extends ChakraV3.TagProps {
  status: RestrictivePracticeStatus;
}

export const RestrictivePracticeStatusTag = (props: Props) => {
  const { status, ...rest } = props;

  const option = restrictivePracticeStatusOptions[status];

  return (
    <ChakraV3.Tag size='sm' colorPalette={option.color} {...rest}>
      {option.label}
    </ChakraV3.Tag>
  );
};
